import { useEffect, useState, type CSSProperties } from 'react';
import { useT } from '@/i18n/useI18n';
import { fetchTips, type GameTip } from './tipsApi';

// Rotating gameplay-hint strip. Shared by the match screen and the
// matchmaking (searching) screen. Tips are admin-authored, fetched once and
// cached for the session, then cycled client-side.
export function TipTicker({ style, intervalMs = 6000 }: { style?: CSSProperties; intervalMs?: number }) {
  const t = useT();
  const [tips, setTips] = useState<GameTip[]>([]);
  const [idx, setIdx] = useState(0);

  useEffect(() => {
    let alive = true;
    void fetchTips().then((list) => { if (alive) setTips(list); });
    return () => { alive = false; };
  }, []);

  useEffect(() => {
    if (tips.length < 2) return;
    const id = window.setInterval(() => setIdx((i) => (i + 1) % tips.length), intervalMs);
    return () => window.clearInterval(id);
  }, [tips.length, intervalMs]);

  if (tips.length === 0) return null;
  const tip = tips[idx % tips.length];

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'baseline',
        gap: 8,
        padding: '7px 12px',
        borderRadius: 8,
        border: '1px solid var(--hairline)',
        background: 'rgba(0,0,0,0.32)',
        ...style,
      }}
    >
      <span
        className="display"
        style={{ fontSize: 9, letterSpacing: '0.14em', color: 'var(--c-yellow)', flexShrink: 0 }}
      >
        {t('match.tip_label')}
      </span>
      <span key={tip.id} style={{ fontSize: 11, lineHeight: 1.35, color: 'var(--ink-muted)', animation: 'count-pop 0.4s ease-out' }}>
        {tip.text}
      </span>
    </div>
  );
}
